export default __webpack_public_path__ + "static/media/illustration-study-1-w@2x.21ab2de7.webp";